import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { REGULATIONS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/regulations/")({
  component: () => <DeptContentList cfg={REGULATIONS} />,
});
